import React from "react";
import TextOverflowEllipsis from "components/common/TextOverflowEllipsis";
import { Timestamp } from "components/common";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
const DefaultColumnRenderers = {
  types: {
    DATE: {
      renderCell: (dateTime) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime }),
      staticWidth: COLUMN_WIDTH.date
    },
    STRING: {
      renderCell: (text) => /* @__PURE__ */ React.createElement(TextOverflowEllipsis, null, text)
    },
    DOUBLE: {
      textAlign: "right"
    },
    INT: {
      textAlign: "right"
    },
    LONG: {
      textAlign: "right"
    }
  },
  attributes: {
    title: {
      staticWidth: COLUMN_WIDTH.title
    },
    name: {
      staticWidth: COLUMN_WIDTH.title
    },
    description: {
      staticWidth: COLUMN_WIDTH.description
    },
    summary: {
      staticWidth: COLUMN_WIDTH.description
    },
    favorite: {
      renderHeader: () => "",
      staticWidth: 30
    }
  }
};
export default DefaultColumnRenderers;
